import { render, staticRenderFns } from "./popup-bx.vue?vue&type=template&id=a3f6df38&scoped=true"
import script from "./popup-bx.vue?vue&type=script&lang=js"
export * from "./popup-bx.vue?vue&type=script&lang=js"
import style0 from "./popup-bx.vue?vue&type=style&index=0&id=a3f6df38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f6df38",
  null
  
)

export default component.exports